angular.module('picmonicng').directive('cancelMonthlyStepper', [
  function () {
    return {
      restrict: 'E',
      scope: {
        product: '=',
      },
      templateUrl: '/templates/directives/cancel-monthly-stepper.html',
      controller: [
        '$rootScope',
        '$scope',
        '$cookies',
        'UserService',
        'User',
        'MarketOptionsConfig',
        'toaster',
        'Upload',
        'BrowseService',
        '$modal',
        function (
          $rootScope,
          $scope,
          $cookies,
          UserService,
          User,
          MarketOptionsConfig,
          toaster,
          Upload,
          BrowseService,
          $modal
        ) {
          $scope.base_asset_url = $rootScope.base_asset_url;
          $scope.exam = {};
          $scope.cancellation = {};
          $scope.loading = false;
          $scope.activeStep = 1;
          $scope.UserService = UserService;
          $scope.referral_url = UserService.getFullReferralUrl();
          $scope.market = MarketOptionsConfig.getMarketById($scope.product.market_id);
          $scope.minDate = new Date($scope.product.max_infusionsoft_next_bill_date * 1000 + 60 * 60 * 24 * 3 * 1000);
          $scope.maxDate = new Date($scope.product.max_infusionsoft_next_bill_date * 1000 + 60 * 60 * 24 * 90 * 1000);
          $scope.currentTimestamp = new Date().getTime() / 1000;
          $scope.BrowseService = BrowseService;

          if ($scope.product.duration_units !== 'monthly' || $scope.product.type !== 1) {
            $scope.stepperVisible = true;
          }

          $scope.exams = [
            { id: 1, name: 'USMLE Step 1', curriculum: 'usmle-step-1' },
            { id: 2, name: 'USMLE Step 2', curriculum: 'usmle-step-2' },
            { id: 4, name: 'COMLEX', curriculum: 'usmle-step-1' },
          ];

          $scope.refundReason = '';

          $scope.copyReferralURL = function () {
            toaster.success('Copied', 'URL has been copied to the clipboard.');
          };

          $scope.setStep = function (step) {
            if (step == 2 && !$scope.cancellation.cancellation_reason) {
              return;
            } else if (
              step == 2 &&
              $scope.cancellation.cancellation_reason &&
              !$scope.loading &&
              $scope.exam &&
              $scope.exam.id &&
              $scope.exam.score
            ) {
              $scope.loading = true;
              $scope.error = '';
              UserService.user.exam = {
                exam_id: $scope.exam.id,
                exam_month: '01',
                exam_year: '2016',
                score: $scope.exam.score,
              };

              UserService.user
                .$update()
                .then(
                  function () {
                    if ($scope.file) {
                      $scope.loading = true;
                      return Upload.upload({
                        url: '/api/v2/exams/upload',
                        data: {
                          file: $scope.file,
                          user_exam_id: UserService.user.exam.user_exam_id,
                        },
                      })
                        .then(
                          function (resp) {
                            $scope.activeStep = step;
                          },
                          function (resp) {
                            $scope.error =
                              'Error uploading exam' + (resp.data && resp.data.error ? ': ' + resp.data.error : '');
                          },
                          function (evt) {
                            $scope.uploadProgress = parseInt((100.0 * evt.loaded) / evt.total);
                          }
                        )
                        .finally(function () {
                          $scope.loading = false;
                        });
                    } else {
                      $scope.activeStep = step;
                    }
                  },
                  function (data) {
                    $scope.error = data.error;
                  }
                )
                .finally(function () {
                  $scope.loading = false;
                });
            } else {
              $scope.loading = false;
              $scope.activeStep = step;
            }
          };

          $scope.cancel = function () {
            if (!$scope.product.confirmation_checkbox) {
              $scope.errorDeletedData =
                'Please confirm above that you understand your data may be deleted when your Premium access expires.';
              return;
            } else {
              $scope.errorDeletedData = '';
            }

            if (!$scope.product.price_confirmation_checkbox) {
              $scope.errorPrice = 'Please check above to confirm.';
              return;
            }
            $scope.errorPrice = '';

            if (!$scope.loading) {
              $scope.loading = true;

              var successCancel = function (step = 4) {
                $scope.product.infusionsoft_status = 0;
                $scope.product.order_on_hold = 0;
                $scope.product.order_status = 0;
                $scope.stepperVisible = true;
                $scope.setStep(step);
              };
              var errorCancel = function (data) {
                $scope.error = data.error;
              };

              User.can_cancel_entitlement({
                users_entitlements_id: $scope.product.users_entitlements_id,
              }).$promise.then(function (data) {
                if (data.can_cancel === true) {
                  User.cancel_entitlement(
                    { users_entitlements_id: $scope.product.users_entitlements_id },
                    $scope.cancellation
                  )
                    .$promise.then(function () {
                      successCancel(4);
                    }, errorCancel)
                    .finally(function () {
                      $scope.loading = false;
                    });
                } else {
                  $scope.loading = false;

                  var outerScope = $scope;
                  var modal = $modal.open({
                    templateUrl: '/templates/modals/cancelation-warning.html',
                    size: 'lg',
                    backdrop: true,
                    controller: [
                      '$scope',
                      function ($scope) {
                        $scope.continue = function () {
                          if (outerScope.loading) {
                            return;
                          }

                          outerScope.loading = true;
                          User.queue_to_cancel_entitlement(
                            { users_entitlements_id: outerScope.product.users_entitlements_id },
                            outerScope.cancellation
                          )
                            .$promise.then(function () {
                              successCancel(7);
                            }, errorCancel)
                            .finally(function () {
                              outerScope.loading = false;
                              modal.close();
                            });
                        };

                        $scope.cancel = function () {
                          modal.close();
                          outerScope.product.cancelVisible = false;
                          outerScope.product.mode = '';
                        };
                      },
                    ],
                  });
                }
              });
            }
          };

          $scope.pause = function () {
            if (!$scope.loading && $scope.pauseForm.$valid && $scope.pauseDate) {
              if (typeof atlasEvent !== 'undefined') {
                atlasEvent('click', 'pause subscription clicked');
              }
              $scope.loading = true;
              $scope.error = '';

              var pausePromise = User.pause_entitlement(
                { users_entitlements_id: $scope.product.users_entitlements_id },
                { pause_date: $scope.pauseDate }
              );

              pausePromise.$promise
                .then(
                  function (data) {
                    $scope.product.order_on_hold = 1;
                    $scope.product.mode = 'pause-success';
                    $scope.product.order_next_bill_date = data.order.next_bill_date;
                  },
                  function (data) {
                    $scope.error = data.data.error;
                  }
                )
                .finally(function () {
                  $scope.loading = false;
                });
            }
          };

          $scope.unpause = function () {
            if (!$scope.loading) {
              $scope.loading = true;
              $scope.error = '';
              $scope.refundSuccess = false;

              var unpausePromise = User.unpause_entitlement(
                { users_entitlements_id: $scope.product.users_entitlements_id },
                {}
              );

              unpausePromise.$promise
                .then(
                  function (data) {
                    $scope.product.order_status = 1;
                    $scope.product.order_on_hold = 0;
                    $scope.product.mode = 'unpause-success';
                    $scope.product.order_next_bill_date = parseInt(data.order.next_bill_date);
                    $scope.product.max_infusionsoft_next_bill_date = parseInt(data.order.next_bill_date);
                  },
                  function (data) {
                    $scope.product.mode = 'unpause-error';
                    $scope.product.order_status = 0;
                    $scope.product.order_on_hold = 0;
                    $scope.error = data.data.error;
                  }
                )
                .finally(function () {
                  $scope.loading = false;
                });
            }
          };

          $scope.refund = function () {
            if ($scope.refundLoading) {
              return;
            }

            if (!$scope.refundReason) {
              $scope.refundError = 'Please provide a reason';
              return;
            }

            $scope.refundLoading = true;
            $scope.refundError = '';

            User.refund_entitlement(
              {
                users_entitlements_id: $scope.product.users_entitlements_id,
                reason: $scope.refundReason,
              },
              {}
            )
              .$promise.then(
                function (result) {
                  $scope.refundSuccess = true;
                  $scope.product.max_infusionsoft_next_bill_date = parseInt(
                    new Date(result.entitlement.infusionsoft_next_bill_date).getTime() / 1000,
                    10
                  );
                  $scope.setStep(6);
                },
                function (error) {
                  if (error.data.errors.reason) {
                    $scope.refundError = 'Please provide a reason.';
                    return;
                  }

                  $scope.refundError = error.data.message;
                }
              )
              .finally(function () {
                $scope.refundLoading = false;
              });
          };

          $scope.skipRefund = function () {
            $scope.refundSkipped = true;
            $scope.setStep(6);
          };

          $scope.goHome = function () {
            window.location = '/home';
          };

          $scope.calculateCancellationDate = function (timestamp) {
            var date = new Date(timestamp * 1000);

            return date.setMonth(date.getMonth() + 1);
          };
        },
      ],
    };
  },
]);
